import {Typography} from '@yandex-delivery/blocks'
import {pipe, reduce} from '@yandex-delivery/utils'
import {type ReactElement} from 'react'

import type {AddressPin, PickupPoint, PickupPointState, UserAddressPin} from './types'

export function isYandexMarketPickupPoint(pickupPoint: PickupPoint): boolean {
  return pickupPoint._type === 'yandex_market'
}

export function isUserAddressPin(x?: AddressPin): x is UserAddressPin {
  return Boolean(x && x.__type === 'user-address-pin')
}

export function renderPickupPointName(pickupPoint: PickupPoint, name: string): ReactElement {
  if (isYandexMarketPickupPoint(pickupPoint)) {
    return (
      <>
        <Typography color="minor" variant="caption1">
          {name}
        </Typography>
        <Typography variant="body2">{pickupPoint.name}</Typography>
      </>
    )
  }

  return <Typography variant="body2">{pickupPoint.name}</Typography>
}

export function renderPointSlotName(pickupPoint: PickupPoint, name: string): ReactElement {
  return (
    <>
      <Typography color="minor" variant="caption1">
        {name}
      </Typography>
      <Typography variant="body2">{pickupPoint.name}</Typography>
    </>
  )
}

type PickupPointStateKey = keyof PickupPointState
type PickupPointStateNames = Record<PickupPointStateKey, string>

const keys: PickupPointStateKey[] = ['pickupPoint', 'phone']

export function createNames(name: string): PickupPointStateNames {
  return pipe(
    keys,
    reduce(function toName(acc, key) {
      acc[key] = `${name}.${key}`

      return acc
    }, {}),
  ) as PickupPointStateNames
}
